<template>
  <div v-loading="loading" element-loading-text="加载中">
    <div class="box">
      <!-- 台账 -->
      <div class="stand">
        <el-row>
          <el-col :span="3" class="elcol">
            <div class="key">
              <div>注册用户数</div>
            </div>
            <div class="number">
              {{ requestData.userCount | numberSlice }}
            </div>
          </el-col>
          <el-col :span="3" class="elcol">
            <div class="key">
              <div>企业数</div>
            </div>
            <div class="number">
              {{ requestData.companyCount }}
            </div>
          </el-col>
          <el-col :span="3" class="elcol">
            <div class="key">
              <div>企业用户数</div>
            </div>
            <div class="number">
              {{ requestData.companyNumByUser }}
            </div>
          </el-col>
          <el-col :span="3" class="elcol">
            <div class="key">
              <div>上线软件个数</div>
            </div>
            <div class="number">
              {{ requestData.productCount }}
            </div>
          </el-col>
          <el-col :span="3" class="elcol">
            <div class="key">
              <div>日活用户数</div>
            </div>
            <div class="number active" @click="dialogVisible = true">
              {{ requestData.userCountByDay }}
            </div>
          </el-col>
          <el-col :span="3" class="elcol">
            <div class="key">
              <div>月活用户数</div>
            </div>
            <div class="number">
              {{ requestData.userCountByMonth }}
            </div>
          </el-col>
          <el-col :span="3" class="elcol">
            <div class="key">
              <div>季活用户数</div>
            </div>
            <div class="number">
              {{ requestData.userCountByQuarter }}
            </div>
          </el-col>
          <el-col :span="3" class="elcol">
            <div class="key">
              <div>用户总积分数</div>
            </div>
            <div class="number">
              {{ requestData.userPointCount | numberSlice }}
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 折线图 -->
      <div class="charts">
        <el-row>
          <el-col :span="12">
            <div class="element-select">
              <el-select v-model="value" @change="pointByHour" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div id="charts-box" v-loading="loading4" element-loading-text="加载中"></div>
          </el-col>

          <el-col :span="12">
            <div class="element-select">
              <el-select v-model="value2" @change="dayVisit" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div id="charts-box-two" v-loading="loading5" element-loading-text="加载中"></div>
          </el-col>

          <el-col :span="12">
            <div class="element-select">
              <el-date-picker
                v-model="visitByMonth_Year"
                type="year"
                @change="MonthVisit"
                value-format="yyyy"
                placeholder="请选择"
                :picker-options="yearPickerOptions"
              >
              </el-date-picker>
            </div>
            <div
              id="charts-box-Three"
              v-loading="loading6"
              element-loading-text="加载中"
            ></div>
          </el-col>

          <el-col :span="12">
            <div class="element-select">
              <el-date-picker
                v-model="visitByQuarter_Year"
                type="year"
                @change="QuarterVisit"
                value-format="yyyy"
                placeholder="请选择"
                :picker-options="yearPickerOptions"
              >
              </el-date-picker>
            </div>
            <div
              id="charts-box-Four"
              v-loading="loading7"
              element-loading-text="加载中"
            ></div>
          </el-col>
        </el-row>
      </div>

      <!-- 图 -->
      <div class="charts-copy" style="height: 510px">
        <el-row>
          <el-col :span="16">
            <div id="charts-box-copy">
              <LeftCharts />
            </div>
          </el-col>

          <el-col :span="8">
            <div id="charts-box-two-copy">
              <RightCharts />
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 图 -->
      <div class="charts" style="height: 400px">
        <el-row>
          <el-col :span="8">
            <Census :userGuishuPie="userGuishuPie" />
          </el-col>

          <el-col :span="16">
            <CensusBar :userGuishuBar="userGuishuBar" />
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- <div class="ftBox">
      <div class="ft">
        <p>
          CopyRight © 2019 Jiangsu Delauney Information Co., Ltd.
          苏ICP备18062906
        </p>
      </div>
    </div> -->

    <ActiveModal v-if="dialogVisible" :dialogVisible.sync="dialogVisible" />
  </div>
</template>
<script>
import echarts from "echarts";
import { API__code, API_control } from "../../api/index.js";
import LeftCharts from "./charts/leftCharts";
import RightCharts from "./charts/rightCharts";
import Census from "./charts/census";
import CensusBar from "./charts/censusBar";
import ActiveModal from "./common/modal";
export default {
  data() {
    return {
      dialogVisible: false,
      token: "",
      checkCode: "",
      value: "1",
      value2: "1",
      chartsXAxis: [],
      //折线图数据
      chartsData: [],
      requestData: "",
      loading: true,
      chartsXAxisTwo: [],
      //折线图数据
      chartsDataTwo: [],
      options: [
        {
          value: "1",
          label: "最近一个月",
        },
        {
          value: "3",
          label: "最近三个月",
        },
        {
          value: "6",
          label: "最近半年",
        },
        {
          value: "12",
          label: "最近一年",
        },
      ],
      loading4: false,
      loading5: false,
      loading6: false,
      loading7: false,
      visitByMonth_Year: String(new Date().getFullYear()),
      visitByQuarter_Year: String(new Date().getFullYear()),
      yearPickerOptions: {
        disabledDate: (time) => {
          const currentYear = new Date().getFullYear();
          const selectedYear = new Date(time).getFullYear();
          return selectedYear > currentYear;
        }
      },
      chartsXAxisThree: [],
      chartsDataThree: [],
      chartsXAxisFour: [],
      chartsDataFour: [],

      userGuishuPie: [],
      userGuishuBar: {},
    };
  },

  created() {
    this.getCookie();
    this.getData();
    this.censusFun();
  },

  mounted() {},

  methods: {
    censusFun() {
      var param = {
        token: this.token,
        checkCode: this.checkCode,
      };
      API_control.getPeiAddress(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.userGuishuPie = res.data.data.pei;
            var bar = {
              x: res.data.data.zhuAddr,
              y: res.data.data.zhuCount,
            };
            this.userGuishuBar = bar;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据丢失，试试重新登陆！");
        });
    },

    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getData() {
      var param = {
        token: this.token,
        checkCode: this.checkCode,
      };
      API_control.getData(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            this.requestData = res.data.data;
            this.pointByHour();
            this.dayVisit();
            this.MonthVisit();
            this.QuarterVisit();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据丢失，试试重新登陆！");
        });
    },

    pointByHour(val) {
      var param = {
        count: this.value,
        token: this.token,
        checkCode: this.checkCode,
      };
      this.loading4 = true;
      API_control.pointByHour(param).then((res) => {
        if (res.data.code == 200) {
          this.chartsXAxis = res.data.data.x;
          this.chartsData = res.data.data.y;
          this.getCharts();
          this.loading4 = false;
        }
      });
    },

    dayVisit(val) {
      var param = {
        count: this.value2,
        token: this.token,
        checkCode: this.checkCode,
      };
      this.loading5 = true;
      API_control.dayVisit(param).then((res) => {
        if (res.data.code == 200) {
          this.chartsXAxisTwo = res.data.data.x;
          this.chartsDataTwo = res.data.data.y;
          this.getChartsTwo();
          this.loading5 = false;
        }
      });
    },

    MonthVisit() {
      var param = {
        year: this.visitByMonth_Year,
        type: "month",
        token: this.token,
        checkCode: this.checkCode,
      };
      this.loading6 = true;
      API_control.yaerVisit(param).then((res) => {
        if (res.data.code == 200) {
          this.chartsXAxisThree = res.data.data.x;
          this.chartsDataThree = res.data.data.y;
          this.getChartsThree();
          this.loading6 = false;
        }
      });
    },

    QuarterVisit() {
      var param = {
        year: this.visitByQuarter_Year,
        type: "quarter",
        token: this.token,
        checkCode: this.checkCode,
      };
      this.loading7 = true;
      API_control.yaerVisit(param).then((res) => {
        if (res.data.code == 200) {
          this.chartsXAxisFour = res.data.data.x;
          this.chartsDataFour = res.data.data.y;
          this.getChartsFour();
          this.loading7 = false;
        }
      });
    },
    
    getCharts() {
      var charts = null;
      charts = echarts.init(document.getElementById("charts-box"));
      charts.showLoading(); //显示等待框
      charts.setOption({
        title: [
          {
            text: "时程积分曲线",
            top: "top",
            left: "left",
            textStyle: {
              color: "#596471",
              fontSize: 17,
              fontWeight: 100,
            },
          },
          // {
          //   text: "近一个月",
          //   top: "top",
          //   left: "115px",
          //   top: "4.2px",
          //   textStyle: {
          //     color: "#596471",
          //     fontSize: 12,
          //     fontWeight: 100,
          //   },
          // },
        ],
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
          formatter: (params) => {
            return `${params[0].name}<br/>${params[0].seriesName}: ${(
              params[0].value + ""
            ).replace(/\B(?=(?:\d{3})+\b)/g, ",")}分`;
          },
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxis,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB",
            },
          },
          axisTick: {
            show: true, //是否显示网状线 默认为true
            alignWithLabel: true,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471",
            },
          },
          splitArea: {},
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisTick: {
            show: true, //是否显示网状线 默认为true
            alignWithLabel: true,
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471",
            },
          },
        },
        series: [
          {
            name: "积分",
            type: "line",
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              normal: {
                color: "#EF5350",
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#FFB87D",
                  },
                  {
                    offset: 1,
                    color: "#ED7D76",
                  },
                ]),
              },
            },
            data: this.chartsData,
            lineStyle: {
              normal: {
                color: "#EF5350",
              },
            },
          },
        ],
      });
      charts.hideLoading(); //隐藏等待框
      this.loading = false;
      window.addEventListener("resize", () => {
        charts.resize();
      }); //自适应图表大小
    },

    getChartsTwo() {
      var charts = null;
      charts = echarts.init(document.getElementById("charts-box-two"));
      charts.showLoading(); //显示等待框
      charts.setOption({
        title: [
          {
            text: "时程日活曲线",
            top: "top",
            left: "10px",
            textStyle: {
              color: "#596471",
              fontSize: 17,
              fontWeight: 100,
            },
          },
          // {
          //   text: "近一个月",
          //   top: "top",
          //   left: "125px",
          //   top: "4.2px",
          //   textStyle: {
          //     color: "#596471",
          //     fontSize: 12,
          //     fontWeight: 100,
          //   },
          // },
        ],
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
          formatter: "{b0}<br/>{a0}: {c0}人",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0],
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisTwo,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB",
            },
          },
          axisTick: {
            show: true, //是否显示网状线 默认为true
            alignWithLabel: true,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471",
            },
          },
          splitArea: {},
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisTick: {
            show: true, //是否显示网状线 默认为true
            alignWithLabel: true,
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471",
            },
          },
        },
        series: [
          {
            name: "人",
            type: "line",
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              normal: {
                color: "#448AFF",
              },
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#74BCFF",
                  },
                  {
                    offset: 1,
                    color: "#3575D6",
                  },
                ]),
              },
            },
            data: this.chartsDataTwo,
            lineStyle: {
              normal: {
                color: "#448AFF",
              },
            },
          },
        ],
      });
      charts.hideLoading(); //隐藏等待框
      this.loading = false;
      window.addEventListener("resize", () => {
        charts.resize();
      }); //自适应图表大小
    },

    getChartsThree() {
      var charts = null;
      charts = echarts.init(document.getElementById("charts-box-Three"));
      charts.showLoading(); // 显示等待框
      charts.setOption({
        title: [
          {
            text: "时程月活曲线",
            top: "top",
            left: "10px",
            textStyle: {
              color: "#596471",
              fontSize: 17,
              fontWeight: 100,
            },
          },
        ],
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
          formatter: "{b0}<br/>{a0}: {c0}人",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0],
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisThree,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB",
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471",
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471",
            },
          },
        },
        series: [
          {
            name: "人",
            type: "line",
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              color: "#2E7D32", // 深绿色，稳重不刺眼
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#A5D6A7",
                  },
                  {
                    offset: 1,
                    color: "#2E7D32",
                  },
                ]),
              },
            },
            data: this.chartsDataThree,
            lineStyle: {
              color: "#2E7D32",
              width: 2,
            },
          },
        ],
      });
      charts.hideLoading(); // 隐藏等待框
      this.loading = false;
      window.addEventListener("resize", () => {
        charts.resize();
      });
    },

    getChartsFour() {
      var charts = null;
      charts = echarts.init(document.getElementById("charts-box-Four"));
      charts.showLoading(); // 显示等待框
      charts.setOption({
        title: [
          {
            text: "时程季活曲线",
            top: "top",
            left: "10px",
            textStyle: {
              color: "#596471",
              fontSize: 17,
              fontWeight: 100,
            },
          },
        ],
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
          formatter: "{b0}<br/>{a0}: {c0}人",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0],
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisFour,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB",
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471",
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471",
            },
          },
        },
        series: [
          {
            name: "人",
            type: "line",
            symbol: "circle",
            symbolSize: 5,
            itemStyle: {
              color: "#546E7A", // 灰蓝色，适合后台系统
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#90A4AE",
                  },
                  {
                    offset: 1,
                    color: "#546E7A",
                  },
                ]),
              },
            },
            data: this.chartsDataFour,
            lineStyle: {
              color: "#546E7A",
              width: 2,
            },
          },
        ],
      });
      charts.hideLoading(); // 隐藏等待框
      this.loading = false;
      window.addEventListener("resize", () => {
        charts.resize();
      });
    },
  },

  filters: {
    numberSlice: (val) => {
      var num = (val + "").replace(/\B(?=(?:\d{3})+\b)/g, ",");
      if (num === "undefined") {
        num = "";
      }
      return num;
    },
  },

  components: {
    LeftCharts,
    RightCharts,
    Census,
    CensusBar,
    ActiveModal,
  },
};
</script>
<style scoped lang="scss">
.element-select {
  float: right;
  position: relative;
  z-index: 888;
}

.box {
  border-radius: 0px;
  width: 100%;
  height: 1000px;
}

.stand {
  border-radius: 2px;
  background-color: white;
  width: 100%;
  height: 120px;
  box-sizing: border-box;
  padding: 32px 18px;
}

.charts {
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border-radius: 2px;
  padding: 32px 28px;
  margin-top: 15px;
}

.ftBox {
  z-index: 9999;
}

.charts-copy {
  width: 100%;
  box-sizing: border-box;
  padding: 0px 21px 0px 0px;
  margin-top: 15px;
}

.key {
  color: #596471;
  font-size: 15px;
}

.key > div {
  float: left;
  overflow: hidden;
}

.number {
  margin-top: 30px;
  font-size: 22px;
}

#charts-box {
  width: 100%;
  height: 400px;
  position: relative;
  top: 0px;
}

#charts-box-two {
  width: 100%;
  height: 400px;
  position: relative;
  top: 0px;
}
#charts-box-Three {
  width: 100%;
  height: 400px;
  position: relative;
  top: 0px;
}
#charts-box-Four {
  width: 100%;
  height: 400px;
  position: relative;
  top: 0px;
}

#charts-box-copy {
  width: 100%;
  height: 510px;
  background-color: white;
  border-radius: 2px;
  padding: 20px;
  box-sizing: border-box;
}

#charts-box-two-copy {
  background-color: white;
  border-radius: 2px;
  width: 100%;
  height: 510px;
  margin-left: 20px;
  padding: 20px;
  box-sizing: border-box;
}

.elcol {
  border-right: 1px solid #d7dae2;
  height: 52px;
  box-sizing: border-box;
  padding: 0px 0px 0px 10px;
}

.elcol:nth-child(8) {
  border-right: 0;
}

.active {
  cursor: pointer;
  color: #2196f3;
}
</style>



// WEBPACK FOOTER //
// Management.vue?48acefba